import React from 'react'

import ItemCardExperimental from '../itemCard/ItemCardExperimental'

const ListThemePreviews = ({
  items,
  viewType,
  currentSite,
  itemDecorator,
  videoMuted,
  muteVideo
}) => {
  return (
    <ul data-test-selector="list-layout" className="product-list">
      {items.map((item, index) => {
        return (
          <li key={item.id}>
            <ItemCardExperimental
              currentSite={currentSite}
              viewType={viewType}
              itemProps={itemDecorator(item, index)}
              videoMuted={videoMuted}
              muteVideo={muteVideo}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default ListThemePreviews



// WEBPACK FOOTER //
// ./client/components/productList/listThemePreviews.js